export {
  getRestrictedSanctionCountries,
  isRestrictedSanctionCountry,
} from "../../utils/restrictedSanctionCountry";

export const hideLinksForSpecifiedCountry = (countryCode) => {
  let shouldLinkBeHidden = false;

  if (
    countryCode &&
    (countryCode?.toUpperCase() === "KR" || // Korea
      countryCode?.toUpperCase() === "IN" || // India
      countryCode?.toUpperCase() === "TW" || // Taiwan
      countryCode?.toUpperCase() === "CN" || // China
      countryCode?.toUpperCase() === "BN" || // Brunei
      countryCode?.toUpperCase() === "MM" || // Myanmar
      countryCode?.toUpperCase() === "KH" || // Cambodia
      countryCode?.toUpperCase() === "ID" || // Indonesia
      countryCode?.toUpperCase() === "LA" || // Laos
      countryCode?.toUpperCase() === "MY" || // Malaysia
      countryCode?.toUpperCase() === "PH" || // Philippines
      countryCode?.toUpperCase() === "SG" || // Singapore
      countryCode?.toUpperCase() === "TH" || // Thailand
      countryCode?.toUpperCase() === "VN" || // Vietnam
      countryCode?.toUpperCase() === "TL") // Timor-Leste
  ) {
    shouldLinkBeHidden = true;
  }

  return shouldLinkBeHidden;
};
